type InputMethod = 'keyboard' | 'mouse';
type KeyboardKey = 'Tab' | 'ArrowUp' | 'ArrowDown' | 'ArrowLeft' | 'ArrowRight' | 'Enter' | 'Other';

class InputMethodTracker {
    private method: InputMethod = 'mouse';
    private lastKey: KeyboardKey | null = null;
    private listeners = new Set<(method: InputMethod, key?: KeyboardKey | null) => void>();

    setMethod(method: InputMethod, key?: KeyboardKey) {
        const changed = this.method !== method || (method === 'keyboard' && this.lastKey !== key);

        this.method = method;
        if (method === 'keyboard' && key) {
            this.lastKey = key;
        } else if (method === 'mouse') {
            this.lastKey = null;
        }

        if (changed) {
            this.listeners.forEach((fn) => fn(method, this.lastKey));
        }
    }

    getMethod() {
        return this.method;
    }

    getLastKey() {
        return this.lastKey;
    }

    isNavigationKey() {
        const navigationKeys: KeyboardKey[] = ['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter'];
        return this.lastKey ? navigationKeys.includes(this.lastKey) : false;
    }

    subscribe(fn: (method: InputMethod, key?: KeyboardKey | null) => void) {
        this.listeners.add(fn);
        return () => this.listeners.delete(fn); // auto cleanup
    }
}

export const inputMethodTracker = new InputMethodTracker();
